import channelObservable from '../../api/channels/channelsObservable';
import Channel from '../../classes/channel';
import { IChannelObservable } from '../../types/interfaces/channel';
import { loadChannels as loadVisibleChannels } from '../../store/thunks/channels.thunk';
import { store } from '../../store/store';
import {
  loadHiddenChannels,
  loadUnavailableChannels,
} from '../../store/slices/channels.slice';

// Data management functions

function loadChannels({
  channels,
  hidden = false,
  unavailable = false,
}: {
  channels: Channel[];
  hidden?: boolean;
  unavailable?: boolean;
}) {
  if (hidden) {
    store.dispatch(loadHiddenChannels(channels));
  } else if (unavailable) {
    store.dispatch(loadUnavailableChannels(channels));
  } else {
    store.dispatch(loadVisibleChannels(channels));
  }
}

// Channel initializers

function initChannels(resetLineup = false) {
  channelObservable(resetLineup).subscribe({
    next: (val: IChannelObservable) => {
      if (val.hiddenChannels) {
        loadChannels({ channels: val.hiddenChannels, hidden: true });
      }
      if (val.unavailableChannels) {
        loadChannels({ channels: val.unavailableChannels, unavailable: true });
      }
      if (val.visibleChannels) {
        loadChannels({ channels: val.visibleChannels });
      }
    },
    error: () => {
      console.error('Error recovering channels data');
    },
    complete: () => {
      return null;
    },
  });
}

export { initChannels };
